// extracted by mini-css-extract-plugin
export default {"formContainer":"signup_formContainer__X1Fwb","addBtn":"signup_addBtn__fHWdy"};